<div class="row">
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'common_total_opens' | translate }}" type="choice_card_a">
      <p class="py-2 icon text-center" [inlineSVG]="'assets/images/icons/icon-stats.svg'"></p>
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ clicksStats.totalClicks ? clicksStats.totalClicks : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'common_unique_opens' | translate }}" type="choice_card_a">
      <p class="py-2 icon text-center" [inlineSVG]="'assets/images/icons/icon-stats.svg'"></p>
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ clicksStats.uniqueClicks ? clicksStats.uniqueClicks : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'stats_richsms_details_views_senturls' | translate }}" type="choice_card_a">
      <p class="py-2 icon text-center" [inlineSVG]="'assets/images/icons/icon-msg-sms.svg'"></p>
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ clicksStats.sentShortUrls ? clicksStats.sentShortUrls : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
  <div class="col-6 col-lg-3 mb-4">
    <wsb-ui-card title="{{ 'stats_richsms_details_percent' | translate }}" type="choice_card_a">
      <p class="py-2 icon text-center percentage">%</p>
      <div class="text-center" wsb-ui-card-footer>
        <span class="number">{{ clicksStats.percentageClickedOnSent ? clicksStats.percentageClickedOnSent : 0 }}</span>
      </div>
    </wsb-ui-card>
  </div>
</div>

<div class="mt-5">
  <div style="display: block;">
    <canvas
      baseChart
      width="400"
      height="200"
      *ngIf="lineChartPerDayOptions"
      [datasets]="lineChartPerDayData"
      [labels]="lineChartPerDayLabels"
      [options]="lineChartPerDayOptions"
      [legend]="lineChartPerDayLegend"
      [type]="lineChartPerDayType"
    >
    </canvas>
  </div>
</div>

<div class="mt-5">
  <div style="display: block;">
    <canvas
      baseChart
      width="400"
      height="200"
      *ngIf="lineChartThreeDayOptions"
      [datasets]="lineChartThreeDayData"
      [labels]="lineChartThreeDayLabels"
      [options]="lineChartThreeDayOptions"
      [legend]="lineChartThreeDayLegend"
      [type]="lineChartThreeDayType"
    >
    </canvas>
  </div>
</div>
